module.exports = __webpack_public_path__ + "static/media/learning.c5e972a0.svg";